module.exports = __webpack_public_path__ + "static/media/lambda-fsw-badge.0c46da70.png";